(function webpackUniversalModuleDefinition(e, r) {
  if (typeof exports === "object" && typeof module === "object") module.exports = r(require("lodash-es/join"), require("lodash-es/random"), require("lodash-es/range"), require("react"), require("tslib"));else if (typeof define === "function" && define.amd) define(["lodash-es/join", "lodash-es/random", "lodash-es/range", "react", "tslib"], r);else if (typeof exports === "object") exports["@mq/aurora-utils"] = r(require("lodash-es/join"), require("lodash-es/random"), require("lodash-es/range"), require("react"), require("tslib"));else e["@mq/aurora-utils"] = r(e["lodash-es/join"], e["lodash-es/random"], e["lodash-es/range"], e["react"], e["tslib"]);
})(typeof self !== "undefined" ? self : this, function (e, r, n, t, o) {
  return function () {
    "use strict";

    var a = {
      882: function (r) {
        r.exports = e;
      },
      669: function (e) {
        e.exports = r;
      },
      759: function (e) {
        e.exports = n;
      },
      297: function (e) {
        e.exports = t;
      },
      780: function (e) {
        e.exports = o;
      }
    };
    var i = {};
    function __webpack_require__(e) {
      var r = i[e];
      if (r !== undefined) {
        return r.exports;
      }
      var n = i[e] = {
        exports: {}
      };
      a[e](n, n.exports, __webpack_require__);
      return n.exports;
    }
    !function () {
      __webpack_require__.n = function (e) {
        var r = e && e.__esModule ? function () {
          return e["default"];
        } : function () {
          return e;
        };
        __webpack_require__.d(r, {
          a: r
        });
        return r;
      };
    }();
    !function () {
      __webpack_require__.d = function (e, r) {
        for (var n in r) {
          if (__webpack_require__.o(r, n) && !__webpack_require__.o(e, n)) {
            Object.defineProperty(e, n, {
              enumerable: true,
              get: r[n]
            });
          }
        }
      };
    }();
    !function () {
      __webpack_require__.o = function (e, r) {
        return Object.prototype.hasOwnProperty.call(e, r);
      };
    }();
    !function () {
      __webpack_require__.r = function (e) {
        if (typeof Symbol !== "undefined" && Symbol.toStringTag) {
          Object.defineProperty(e, Symbol.toStringTag, {
            value: "Module"
          });
        }
        Object.defineProperty(e, "__esModule", {
          value: true
        });
      };
    }();
    var u = {};
    !function () {
      __webpack_require__.r(u);
      __webpack_require__.d(u, {
        AG_GRID_LICENSE_KEY: function () {
          return l;
        },
        TS_W_WBPK: function () {
          return e;
        },
        ThemeConsumer: function () {
          return d;
        },
        ThemeContext: function () {
          return p;
        },
        emailConfigs: function () {
          return b;
        },
        generateErrorReportEmailString: function () {
          return generateErrorReportEmailString;
        },
        generateId: function () {
          return generateId;
        }
      });
      var e = 1;
      var r = __webpack_require__(780);
      var n = __webpack_require__(882);
      var t = __webpack_require__.n(n);
      var o = __webpack_require__(669);
      var a = __webpack_require__.n(o);
      var i = __webpack_require__(759);
      var _ = __webpack_require__.n(i);
      var c = t()((0, r.__spreadArray)((0, r.__spreadArray)((0, r.__spreadArray)([], _()(48, 58)), _()(65, 91)), _()(97, 123)).map(function (e) {
        return String.fromCharCode(e);
      }), "");
      var generateId = function (e) {
        if (e === void 0) {
          e = 8;
        }
        var r = "";
        for (var n = 0; n < e; n++) {
          r += c[a()(0, c.length - 1)];
        }
        return r;
      };
      var s = __webpack_require__(297);
      var f = {
        theme: "light",
        setTheme: function (e) {
          return null;
        }
      };
      var p = s.createContext(f);
      var d = p.Consumer;
      var l = "CompanyName=Goldman Sachs (HQ),LicensedApplication=GS Site,LicenseType=SingleApplication,LicensedConcurrentDeveloperCount=-1,LicensedProductionInstancesCount=-1,AssetReference=AG-008966,ExpiryDate=19_August_2022_[v2]_MTY2MDg2MzYwMDAwMA==1e5c8db8d4533ef7c651c2a6e690a187";
      var b = {
        chunkError: {
          body: "Hello Marquee Support, %0A %0A <Insert feature name> did not load properly due to a failure when downloading the page. Can you please assist? %0A %0A Thank you, %0A <Insert your name>",
          email: "gs-marquee-help%40gs.com"
        }
      };
      var generateErrorReportEmailString = function (e, r, n) {
        return "mailto:" + e + "?subject=" + r + "&body=" + n;
      };
    }();
    return u;
  }();
});